import React from 'react';
import { Card, Modal, QRCode } from 'antd';
import { AndroidOutlined, AppleOutlined } from '@ant-design/icons';

export default function PlayStoreModal({ open, toggle }) {
  const data = [
    {
      title: 'Apple Store',
      link: 'itms-apps://itunes.apple.com/app/6504524760',
      icon: <AppleOutlined />,
    },
    {
      title: 'Google Play',
      link: 'https://play.google.com/store/apps/details?id=com.amigorestaurantdashboardnativeapp',
      icon: <AndroidOutlined />,
    },
  ];

  return (
    <Modal open={open} onCancel={() => toggle(false)} footer={null} title="">
      <div className="grid grid-cols-2 gap-4">
        {data.map((item, index) => (
          <Card
            title={
              <span>
                {item.title} {item.icon}
              </span>
            }
            className="w-full h-full"
            key={`app-icon-${index}`}
          >
            <QRCode value={item.link} className="h-full w-full border-none m-auto" />
          </Card>
        ))}
      </div>
    </Modal>
  );
}
